import styled from "styled-components";

export const StatePopupWrapperBox = styled.div`
    max-width: 560px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;

    width: 25vw;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        width: 82vw;
    }
    @media ${({theme}) => theme.mediaQuery.lAndBelow + " and " + theme.mediaQuery.landscape} {
        width: 56vw;
    }
`;
